import { Button } from 'antd';
import React from 'react';
import styled, { css } from 'styled-components';
import { CaretRightOutlined } from '@ant-design/icons';

// изъятие isDisableExecute, чтобы не пробрасывалось в DOM элемент
// и не кидало warning в консоль
const StyledButton = styled(({ isDisableExecute, ...props }) => <Button {...props} />)`
  ${({ isDisableExecute }) =>
    isDisableExecute &&
    css`
      color: white;
      background-color: rgb(172, 216, 252);
    `}
`;

const ButtonExecuteDashboard = ({ isDisableExecute, onExecuteQuery }) => {
  return (
    <StyledButton
      type="primary"
      isDisableExecute={isDisableExecute}
      disabled={isDisableExecute}
      onClick={() => onExecuteQuery()}
    >
      <CaretRightOutlined />
      Execute dashboard
    </StyledButton>
  );
};

export default ButtonExecuteDashboard;
